module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_101.25deg.3b36a11e.png";